export const settingsItems = [
  {
    id: 'profile-button',
    nextdown: 'tune-start-button',
    className: 'profile-button',
    classNameFocused: 'profile-button-focused',
  },
  {
    id: 'tune-start-button',
    nextup: 'profile-button',
    nextdown: 'autoplay-on-demand-button',
    className: 'middle-section-large-button',
    classNameFocused: 'middle-section-large-button-focused',
    content: 'TuneStart',
    settingsName: 'TuneStart',
    toggle: true,
  },
  {
    id: 'autoplay-on-demand-button',
    nextup: 'tune-start-button',
    nextdown: 'autoplay-on-startup-button',
    className: 'middle-section-large-button',
    classNameFocused: 'middle-section-large-button-focused',
    content: 'Autoplay on Demand',
    settingsName: 'AutoPlay',
    toggle: true,
  },
  {
    id: 'autoplay-on-startup-button',
    nextup: 'autoplay-on-demand-button',
    nextdown: 'legal-button',
    className: 'middle-section-large-button',
    classNameFocused: 'middle-section-large-button-focused',
    content: 'Autoplay on Startup',
    toggle: true,
    useStorageService: true,
  },
  {
    id: 'legal-button',
    nextup: 'autoplay-on-startup-button',
    nextdown: 'sign-out-button',
    className: 'middle-section-button',
    classNameFocused: 'middle-section-button-focused',
    content: 'Legal',
    toggle: false,
  },
  {
    id: 'sign-out-button',
    nextup: 'legal-button',
    className: 'sign-out-button',
    classNameFocused: 'sign-out-button-focused',
    content: 'Sign Out',
    toggle: false,
  },
];

export const settingsToggleItems = ['TuneStart', 'AutoPlay'];

export const legalButtonExtra = [
  {
    title: 'legalPage.termsText',
    website: 'legalPage.termsLink',
  },
  {
    title: 'legalPage.privacyText',
    website: 'legalPage.privacyLink',
  },
  {
    title: 'legalPage.doNotSellText',
    website: 'legalPage.doNotSellLink',
  },
];

export const popupCloseButtonNav = {
  id: 'popup-close-button',
  nextright: 'popup-sign-out-button',
};

export const popupSignOutButtonNav = {
  id: 'popup-sign-out-button',
  nextleft: 'popup-close-button',
};

export type SettingsConfig = {
  rightSideTitle?: string;
  rightSideDetail?: string;
  trackFocus?: string;
  autoplayOnStartup?: string;
  appVersion?: string;
  appBuild?: string;
  showVersion?: boolean;
  translateTitle?: string;
};
